import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1014"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6.932.993h5.411c.264 0 .423.292.279.514L9.643 5.118a.155.155 0 0 0 .13.24h3.134c.417 0 .632.498.346.802L3.99 16.001 6.196 8.42a.156.156 0 0 0-.149-.199H2.844a.475.475 0 0 1-.416-.706l4.007-6.23c.1-.18.29-.292.497-.292z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }